"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PlayerStatisticsDetailsCtl_1 = require("../../../ctl/PlayerStatisticsDetailsCtl");
var PlayerDetailExpander = /** @class */ (function (_super) {
    __extends(PlayerDetailExpander, _super);
    function PlayerDetailExpander(props) {
        var _this = _super.call(this, props) || this;
        _this._SDetails = null;
        _this.SID = 0;
        return _this;
    }
    PlayerDetailExpander.prototype.componentWillMount = function () {
        var _this = this;
        this._SDetails = new PlayerStatisticsDetailsCtl_1.PlayerStatisticsDetailsCtl(this.props.state.getErrDialog());
        this.SID = this._SDetails.Subscribe("*", function (id, data) {
            _this.setState({ Data: data });
        });
        this.setState({
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            Data: {
                total_deposits_count: 0,
                custom_zone_title: "",
                is_custom_zone: false,
                range_bet_bonus_amount: 0,
                range_bet_money_amount: 0,
                range_bonus_completed_amount: 0,
                range_bonus_completed_count: 0,
                range_brand_profit_amount: 0,
                range_comission_deposit_amount: 0,
                range_comission_withdraw_amount: 0,
                range_deposit_amount: 0,
                range_deposits_count: 0,
                range_partner_profit_amount: 0,
                range_win_bonus_amount: 0,
                range_win_money_amount: 0,
                range_withdraw_amount: 0,
                range_withdraws_count: 0,
                total_bet_bonus_amount: 0,
                total_bet_money_amount: 0,
                total_bonus_completed_amount: 0,
                total_bonus_completed_count: 0,
                total_brand_profit_amount: 0,
                total_comission_deposit_amount: 0,
                total_comission_withdraw_amount: 0,
                total_deposit_amount: 0,
                total_partner_profit_amount: 0,
                total_win_bonus_amount: 0,
                total_win_money_amount: 0,
                total_withdraw_amount: 0,
                total_withdraws_count: 0,
                multiaccounts_count_by_withdraws: 0,
                multiaccounts_count_by_ip: 0,
                multiaccounts_count_by_password: 0
            }
        }, function () {
            _this._SDetails.LoadData({
                usr_player_id: _this.props.player.key,
                from_year: _this.state.dtFrom.get('year'),
                from_month: _this.state.dtFrom.get('month') + 1,
                from_day: _this.state.dtFrom.get('date'),
                to_year: _this.state.dtTo.get('year'),
                to_month: _this.state.dtTo.get('month') + 1,
                to_day: _this.state.dtTo.get('date'),
            });
        });
    };
    PlayerDetailExpander.prototype.componentWillUnmount = function () {
        this._SDetails.UnSubscribe(this.SID);
    };
    PlayerDetailExpander.prototype.buttonClick = function () {
        // if (this.props.onClick) {
        //     this.props.onClick();
        // }
    };
    PlayerDetailExpander.prototype.bool2Str = function (val) {
        if (val) {
            return "ДА";
        }
        else {
            return "НЕТ";
        }
    };
    PlayerDetailExpander.prototype.getSelfExcludeText = function (rec) {
        if (rec.is_self_exclude) {
            return rec.self_exclude_date.format(this.props.state.getDateTimeFormat());
        }
        else {
            return "НЕТ";
        }
    };
    PlayerDetailExpander.prototype.getRangeRtp = function () {
        if (this.state.Data.range_bet_money_amount == 0) {
            return "0%";
        }
        var dt = this.state.Data.range_bet_money_amount - this.state.Data.range_win_money_amount;
        dt = (1 - dt / this.state.Data.range_bet_money_amount) * 100;
        return dt.toFixed(2);
    };
    PlayerDetailExpander.prototype.getTotalRtp = function () {
        if (this.state.Data.total_bet_money_amount == 0) {
            return "0%";
        }
        var dt = this.state.Data.total_bet_money_amount - this.state.Data.total_win_money_amount;
        dt = (1 - dt / this.state.Data.total_bet_money_amount) * 100;
        return dt.toFixed(2);
    };
    PlayerDetailExpander.prototype.getFromStr = function () {
        return this.state.dtFrom.get('year') + "-" + (this.state.dtFrom.get('month') + 1) + "-" + this.state.dtFrom.get('date');
    };
    PlayerDetailExpander.prototype.getToStr = function () {
        return this.state.dtTo.get('year') + "-" + (this.state.dtTo.get('month') + 1) + "-" + this.state.dtTo.get('date');
    };
    PlayerDetailExpander.prototype.getRenderObject = function () {
        return (React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                    " [",
                    this.props.player.key,
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                    " [",
                    this.props.player.date_added.format(this.props.state.getDateTimeFormat()),
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                    " [",
                    this.props.player.date_changed.format(this.props.state.getDateTimeFormat()),
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0412\u0430\u043B\u044E\u0442\u0430:"),
                    " [",
                    this.props.player.app_currency_title,
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u042F\u0437\u044B\u043A \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430:"),
                    " [",
                    this.props.player.app_language_title,
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u0435\u043D\u044C\u0433\u0438:"),
                    " [",
                    this.props.player.money_balance.toFixed(2),
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0439\u043D\u0442\u044B:"),
                    " [",
                    this.props.player.points_balance.toFixed(2),
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0415\u041C\u044D\u0439\u043B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D:"),
                    " [",
                    this.bool2Str(this.props.player.is_email_confirmed),
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0412\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D:"),
                    " [",
                    this.bool2Str(this.props.player.is_verifed),
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0441\u0442\u0430\u0432\u043E\u043A:"),
                    " [",
                    this.props.player.total_bet_amount.toFixed(2),
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:"),
                    " [",
                    this.props.player.description,
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0430\u043C\u043E\u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435:"),
                    " [",
                    this.bool2Str(this.props.player.is_self_exclude),
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0414\u0430\u0442\u0430 \u0441\u0430\u043C\u043E\u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F:"),
                    " [",
                    this.getSelfExcludeText(this.props.player),
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0410\u0444\u0444\u0438\u043B\u0435\u0439\u0442:"),
                    " [",
                    this.props.player.affilate_title,
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041F\u0430\u0440\u0442\u043D\u0435\u0440:"),
                    " [",
                    this.props.player.partner_login,
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041E\u0444\u0444\u0435\u0440:"),
                    " [",
                    this.props.player.partner_offer_title,
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0422\u0440\u0435\u043A\u0435\u0440:"),
                    " [",
                    this.props.player.partner_tracker_title,
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0418\u0433\u0440\u043E\u043A \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D \u043D\u0430 EMail \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0443:"),
                    " [",
                    this.bool2Str(this.props.player.is_agree_on_email_subscription),
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0418\u0433\u0440\u043E\u043A \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u0443\u044E \u0437\u043E\u043D\u0443:"),
                    " [",
                    this.bool2Str(this.props.player.is_custom_zone),
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0417\u043E\u043D\u0430 \u0438\u0433\u0440\u043E\u043A\u0430:"),
                    " [",
                    this.props.player.custom_gameprovider_zone_title,
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0435\u0433\u043C\u0435\u043D\u0442 \u0438\u0433\u0440\u043E\u043A\u0430:"),
                    " [",
                    this.props.player.profit_status_title,
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0414\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u0430\u044F \u0437\u043E\u043D\u0430 :"),
                    " [",
                    this.props.player.trust_zone_title,
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041F\u0435\u0440\u0435\u0441\u0435\u0447\u0435\u043D\u0438\u0439 \u043F\u043E IP:"),
                    " [",
                    this.state.Data.multiaccounts_count_by_ip,
                    "]"),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041F\u0435\u0440\u0435\u0441\u0435\u0447\u0435\u043D\u0438\u0439 \u043F\u043E \u043F\u0430\u0440\u043E\u043B\u044E:"),
                    " [",
                    this.state.Data.multiaccounts_count_by_password,
                    "]")),
            React.createElement("div", { style: { marginLeft: "20px" } },
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0437\u0430 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442:"),
                    " [",
                    this.getFromStr(),
                    " :: ",
                    this.getToStr(),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0432 :"),
                    " [",
                    this.state.Data.range_deposits_count,
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0441\u043D\u044F\u0442\u0438\u0439 :"),
                    " [",
                    this.state.Data.range_withdraws_count,
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0432 :"),
                    " [",
                    this.state.Data.range_deposit_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0441\u043D\u044F\u0442\u0438\u0439 :"),
                    " [",
                    this.state.Data.range_withdraw_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0441\u0442\u0430\u0432\u043E\u043A \u0434\u0435\u043D\u0435\u0433 :"),
                    " [",
                    this.state.Data.range_bet_money_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0435\u0439 \u0434\u0435\u043D\u0435\u0433 :"),
                    " [",
                    this.state.Data.range_win_money_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0441\u0442\u0430\u0432\u043E\u043A \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                    " [",
                    this.state.Data.range_bet_bonus_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0435\u0439 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                    " [",
                    this.state.Data.range_win_bonus_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0414\u043E\u0445\u043E\u0434 \u0431\u0440\u0435\u043D\u0434\u0430 :"),
                    " [",
                    this.state.Data.range_brand_profit_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0414\u043E\u0445\u043E\u0434 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 :"),
                    " [",
                    this.state.Data.range_partner_profit_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0445 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                    " [",
                    this.state.Data.range_bonus_completed_count,
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0445 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                    " [",
                    this.state.Data.range_bonus_completed_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0439 :"),
                    " [",
                    this.state.Data.range_comission_deposit_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439 \u0441\u043D\u044F\u0442\u0438\u0439 :"),
                    " [",
                    this.state.Data.range_comission_withdraw_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041E\u0442\u0434\u0430\u0447\u0430:"),
                    " [",
                    this.getRangeRtp(),
                    "] ")),
            React.createElement("div", { style: { marginLeft: "40px" } },
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0437\u0430 \u0432\u0441\u0435 \u0432\u0440\u0435\u043C\u044F")),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0432 :"),
                    " [",
                    this.state.Data.total_deposits_count,
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0441\u043D\u044F\u0442\u0438\u0439 :"),
                    " [",
                    this.state.Data.total_withdraws_count,
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0432 :"),
                    " [",
                    this.state.Data.total_deposit_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0441\u043D\u044F\u0442\u0438\u0439 :"),
                    " [",
                    this.state.Data.total_withdraw_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0441\u0442\u0430\u0432\u043E\u043A \u0434\u0435\u043D\u0435\u0433 :"),
                    " [",
                    this.state.Data.total_bet_money_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0435\u0439 \u0434\u0435\u043D\u0435\u0433 :"),
                    " [",
                    this.state.Data.total_win_money_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0441\u0442\u0430\u0432\u043E\u043A \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                    " [",
                    this.state.Data.total_bet_bonus_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0435\u0439 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                    " [",
                    this.state.Data.total_win_bonus_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0414\u043E\u0445\u043E\u0434 \u0431\u0440\u0435\u043D\u0434\u0430 :"),
                    " [",
                    this.state.Data.total_brand_profit_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0414\u043E\u0445\u043E\u0434 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 :"),
                    " [",
                    this.state.Data.total_partner_profit_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0445 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                    " [",
                    this.state.Data.total_bonus_completed_count,
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0445 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                    " [",
                    this.state.Data.total_bonus_completed_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0439 :"),
                    " [",
                    this.state.Data.total_comission_deposit_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439 \u0441\u043D\u044F\u0442\u0438\u0439 :"),
                    " [",
                    this.state.Data.total_comission_withdraw_amount.toFixed(2),
                    "] "),
                React.createElement("div", null,
                    React.createElement("b", null, "\u041E\u0442\u0434\u0430\u0447\u0430:"),
                    " [",
                    this.getTotalRtp(),
                    "] "))));
    };
    PlayerDetailExpander.prototype.render = function () {
        return this.getRenderObject();
    };
    return PlayerDetailExpander;
}(React.Component));
exports.default = PlayerDetailExpander;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/expander/PlayerDetailExpander.tsx
// module id = 1919
// module chunks = 0